import { render, staticRenderFns } from "./proTable.vue?vue&type=template&id=d11aebf0&scoped=true"
import script from "./proTable.vue?vue&type=script&lang=js"
export * from "./proTable.vue?vue&type=script&lang=js"
import style0 from "./proTable.vue?vue&type=style&index=0&id=d11aebf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11aebf0",
  null
  
)

export default component.exports